import { z } from 'zod'

import { nodeSidepanelSchema } from './nodeSidepanelSchema'

export const approvalFormSchema = nodeSidepanelSchema.extend({
  nodeType: z.literal('approvals'),
  nodeData: z.object({
    handlerType: z.string(),
    payload: z.object({}),
  }),
})

export type ApprovalFormSchema = z.infer<typeof approvalFormSchema>
